import { formatCurrency } from '@/utils';
import { Flex, FormControl } from '@chakra-ui/react';
import { Box, Checkbox, Text } from '@cmpsr/components';
import { UseFormReturn } from 'react-hook-form';
import { PaymentFormState } from '../PPRAPaymentPage';

interface TermsSectionProps {
  form: UseFormReturn<PaymentFormState>;
  currentPrice: number | null;
}

// Checkbox styles
const checkboxStyles = {
  '.chakra-checkbox__control': {
    borderRadius: '4px',
    borderColor: 'darkBlue',
    backgroundColor: 'transparent',
    display: 'flex',
    width: '25px',
    height: '25px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    _checked: {
      backgroundColor: 'lightBlue',
      borderColor: 'lightBlue',
      color: 'darkBlue',
    },
    _invalid: {
      borderColor: 'salmon-light',
    },
    color: 'darkBlue',
  },
  '.chakra-checkbox__label': {
    display: 'flex',
    alignItems: 'center',
    height: '25px',
    padding: 0,
  },
} as const;

// Checkbox text styles
const checkboxTextStyles = (isError: boolean) => ({
  variant: 'text-body-meta-regular' as const,
  ml: '0.250rem',
  color: isError ? 'salmon-light' : 'darkBlue',
  fontSize: '14px',
  display: 'block',
  lineHeight: '140%',
});

const TermsSection = ({ form, currentPrice }: TermsSectionProps) => {
  const formattedPrice = currentPrice ? formatCurrency(currentPrice) : 'loading...';

  return (
    <Box width="100%" backgroundColor="transparent" display="flex" flexDirection="column" gap="25px">
      <FormControl id="checkboxAgreement" isInvalid={!!form.formState.errors.autoRenewal}>
        <Flex alignItems="center" gap="15px">
          <Checkbox
            aria-label="Membership auto-Renewal agreement"
            size="l"
            sx={checkboxStyles}
            {...form.register('autoRenewal', {
              required: 'You must agree to the auto-renewal terms',
            })}
            isInvalid={!!form.formState.errors.autoRenewal}
          ></Checkbox>
          <Text {...checkboxTextStyles(!!form.formState.errors.autoRenewal)}>
            By checking this box, I agree that my membership will auto-renew each year at the standard rate (currently{' '}
            {formattedPrice}/year) until canceled
          </Text>
        </Flex>
      </FormControl>
    </Box>
  );
};

export default TermsSection;
